import { EHeadingStyleVariant, ETextStyleVariant, Heading, Text } from '@outdoorsyco/bonfire';
import cn from 'classnames';
import Image from 'next/image';
import React from 'react';

import MaxWidth from '@/components/common/layout/MaxWidth';

import css from './SeasonalGuideSectionArticles.module.css';
import { TSeasonalGuideSectionArticle } from './types';

type TSeasonalGuideSectionArticlesProps = {
  headingAlign: 'left' | 'right';
  articles: TSeasonalGuideSectionArticle[];
};

export const SeasonalGuideSectionArticles = ({
  headingAlign,
  articles,
}: TSeasonalGuideSectionArticlesProps) => {
  return (
    <MaxWidth className="pb-2 mx-auto overflow-auto md:overflow-visible -mt-28 lg:-mt-36 md:pb-0">
      <div className={`grid grid-flow-col md:grid-cols-${articles.length} gap-x-6 lg:gap-x-10`}>
        {articles.map((article, index) => (
          <a
            key={index}
            target="_blank"
            rel="noreferrer"
            href={article.url}
            className={cn(
              'flex flex-col overflow-hidden rounded-lg md:rounded-2xl w-[250px] md:w-auto',
              {
                [css.parallaxArticleLeft as string]: headingAlign === 'right',
                [css.parallaxArticleRight as string]: headingAlign === 'left',
              },
            )}>
            <div className="relative bg-gray-500 h-[224px] md:h-[324px]">
              <Image
                alt=""
                src={article.imageUrl}
                role="presentation"
                layout="fill"
                objectFit="cover"
                objectPosition="center"
                placeholder={article.imageBlurDataUrl ? 'blur' : 'empty'}
                blurDataURL={article.imageBlurDataUrl}
                quality={45}
              />
            </div>

            <div
              className="flex flex-col flex-grow p-6 text-white gap-1.5"
              style={{ backgroundColor: article.backgroundColor }}>
              <Heading component="div" variant={EHeadingStyleVariant.H6} className="text-center">
                {article.title}
              </Heading>

              <Text
                variant={ETextStyleVariant.MediumBold}
                className="font-normal text-center underline md:font-medium">
                {article.description}
              </Text>
            </div>
          </a>
        ))}
      </div>
    </MaxWidth>
  );
};
